import { render, staticRenderFns } from "./OverlayReviewRequest.vue?vue&type=template&id=768467b8&scoped=true"
import script from "./OverlayReviewRequest.vue?vue&type=script&lang=js"
export * from "./OverlayReviewRequest.vue?vue&type=script&lang=js"
import style0 from "./OverlayReviewRequest.vue?vue&type=style&index=0&id=768467b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768467b8",
  null
  
)

export default component.exports